/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import { AppBar, Box, Container, Grid, Paper, Toolbar, Typography } from "@mui/material";
import ChangePassword from "../../../../components/Administrations/AccessControls/Users/ChangePassword/ChangePassword";
import { useGeneralData } from "./hooks";
import { APP_BAR_TEXT } from "../../../../globals/globals";
import { Link } from "react-router-dom";

const Password: React.FC = () => {
  const {
    containerStyle,
    cancelHandler } = useGeneralData();

  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: "var(--primary)" }}>
        <Box display="flex" alignItems="center" sx={{ height: 65 }} >
          <Container maxWidth={false}>
            <Toolbar disableGutters>
              <Typography
                variant="h6"
                noWrap
                component={Link}
                to=""
                sx={{ ml: 2.5, fontWeight: 500, textDecoration: "none", color: "inherit", mr: 2.5, display: { xs: "none", md: "flex" } }}>
                |
              </Typography>
              <Typography
                variant="h6"
                noWrap
                component={Link}
                to=""
                sx={{ fontWeight: 500, textDecoration: "none", color: "inherit", mr: "8%", display: { xs: "none", md: "flex" } }}>
                {APP_BAR_TEXT}
              </Typography>
            </Toolbar></Container>
        </Box>
      </AppBar>
      <Grid container sx={containerStyle}>
        <Grid item>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            sx={{ backgroundColor: "var(--card)", p: 2, mt: 5 }} >
            <Paper elevation={3} sx={{ p: 4, borderRadius: 3, maxWidth: 600, backgroundColor: "var(--card)" }}>
              <Typography variant="h5" mb={3} textAlign="left">
                Reset Password
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <ChangePassword cancelHandler={cancelHandler} isReset={true} />
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Password;